import React from 'react';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div><a href="https://github.com/KhobbyLynx" target="_blank" rel="noopener noreferrer"><BsGithub /></a></div>
          <div><a href="http://linkedin.com/in/samuel-tetteh/" target="_blank" rel="noopener noreferrer"><BsLinkedin /></a></div>
          <div><a href="https://web.facebook.com/lynx.ba.1" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a></div>
    </div>
  )
}

export default SocialMedia